<template>
  <kye-checkbox
    class="drag-box-item menu-tag"
    :label="tag.id"
    :disabled="!isBatchFlag"
    :class="{'active-tag': isActive, 'tag-none': !isBatchFlag}">
    <img :src="menuIcon" />
    <span class="tag-text">{{ tag.title }}</span>
    <template v-if="!isBatchFlag">
      <el-dropdown @command="handleCommand" trigger="click" placement="bottom-start" @visible-change="visibleChange">
        <div class="more-icon-box" :class="{'visible': visible}"></div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="move" class="layout-tag-action-row">
            <img src="../../../images/move.svg" style="width: 14px;height: 14px" alt="">移动到
          </el-dropdown-item>
          <el-dropdown-item command="delete" class="layout-tag-action-row delete">
            <img src="../../../images/delete.svg" alt="">移除
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </kye-checkbox>
</template>

<script>
import emptyIcon from '@/layout/components/images/empty-icon.png'
export default {
  name: 'ModuleItem',
  props: {
    tag: {
      type: Object,
      required: true
    },
    isBatchFlag: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    menuIcon: {
      type: String,
      default: emptyIcon
    }
  },
  data () {
    return {
      visible: false
    }
  },
  methods: {
    handleCommand(command) {
      this.$emit('command', command, this.tag)
    },
    visibleChange (val) {
      console.log(val)
      this.visible = val
    }
  }
}
</script>

<style lang="scss" scoped>
.drag-box-item {
  cursor: move;
  width: 214px;
  height: 56px;
  box-sizing: border-box;
  padding: 0 12px;
  margin: 0 !important;
  display: flex;
  align-items: center;
  border-radius: 8px;
  background: rgba(249, 249, 254, 1);
  border: 1px solid transparent;
  position: relative;
  /deep/ .el-checkbox__input {
    position: absolute;
    right: 0;
    bottom: -1px;
    border-radius: 8px 0 8px 0;
    overflow: hidden;
    display: none;
    &.is-checked {
      display: block;
      width: 16px;
      height: 16px;
    }
    .el-checkbox__inner{
      width: 16px;
      height: 16px;
      border: none;
      border-radius: 0;
      &::after {
        top: 2px;
        left: 6px;
      }
    }
  }
  /deep/ .el-checkbox__label {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    padding-left: 0;
    line-height: normal;
  }
  img {
    display: block;
    width: 48px;
    height: 48px;
    margin-right: 4px;
  }
  .tag-text {
    color: rgba(69, 60, 90, 1);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .more-icon-box {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    cursor: pointer;
    background: url("../../../images/more.svg") no-repeat center center / 12px;
    border-radius: 3px;
    &:hover {
      background: url("../../../images/more-hover.svg") no-repeat center center / 12px;
      border: 1px solid rgba(121, 83, 246, 0.1);
    }
    &.visible{
      background: url("../../../images/more-hover.svg") no-repeat center center / 12px;
      border: 1px solid rgba(121, 83, 246, 0.1);
    }
  }
  &.active-tag {
    border: 1px solid #8b60f0;
  }
  &.tag-none {
    /deep/ .el-checkbox__input {
      display: none;
    }
    /deep/ .el-checkbox__input.is-disabled + span.el-checkbox__label {
      color: var(--g-theme-color-text);
      cursor: move;
    }
  }
}

.layout-tag-action-row {
  display: flex;
  align-items: center;
  height: 34px;
  padding: 0 16px;
  cursor: pointer;
  &.delete{
    color: rgba(255, 41, 16, 1) !important;
    &:hover {
      color: rgba(255, 41, 16, 1) !important;
      background-color: rgba(255, 41, 16, 0.1) !important;
    }
  }
  &:hover {
    background-color: rgba(245, 247, 250, 1) !important;
    color: #1d1c23 !important;
  }
  img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    flex-shrink: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/common-menu-card/menu-group-dialog/module-list/module-item.vue